import LimitedTokensActionTypes from './limitedTokens-types'

export const startFetchAvailableLimitedTokens = data => ({
    type: LimitedTokensActionTypes.START_FETCH_AVAILABLE_LIMITED_TOKENS,
    payload: data,
})
export const successFetchAvailableLimitedTokens = data => ({
    type: LimitedTokensActionTypes.SUCCESS_FETCH_AVAILABLE_LIMITED_TOKENS,
    payload: data,
})
export const finishFetchAvailableLimitedTokens = data => ({
    type: LimitedTokensActionTypes.FINISH_FETCH_AVAILABLE_LIMITED_TOKENS,
    payload: data,
})
export const failureFetchAvailableLimitedTokens = data => ({
    type: LimitedTokensActionTypes.FAILURE_FETCH_AVAILABLE_LIMITED_TOKENS,
    payload: data,
})

export const startBuyLimitedTokens = data => ({
    type: LimitedTokensActionTypes.START_BUY_LIMITED_TOKENS,
    payload: data,
})
export const successBuyLimitedTokens = data => ({
    type: LimitedTokensActionTypes.SUCCESS_BUY_LIMITED_TOKENS,
    payload: data,
})
export const finishBuyLimitedTokens = data => ({
    type: LimitedTokensActionTypes.FINISH_BUY_LIMITED_TOKENS,
    payload: data,
})
export const failureBuyLimitedTokens = data => ({
    type: LimitedTokensActionTypes.FAILURE_BUY_LIMITED_TOKENS,
    payload: data,
})

export const startTransferLimitedTokens = data => ({
    type: LimitedTokensActionTypes.START_TRANSFER_LIMITED_TOKENS,
    payload: data,
})
export const successTransferLimitedTokens = data => ({
    type: LimitedTokensActionTypes.SUCCESS_TRANSFER_LIMITED_TOKENS,
    payload: data,
})
export const finishTransferLimitedTokens = data => ({
    type: LimitedTokensActionTypes.FINISH_TRANSFER_LIMITED_TOKENS,
    payload: data,
})
export const failureTransferLimitedTokens = data => ({
    type: LimitedTokensActionTypes.FAILURE_TRANSFER_LIMITED_TOKENS,
    payload: data,
})

export const startWithdrawLimitedTokens = data => ({
    type: LimitedTokensActionTypes.START_WITHDRAW_LIMITED_TOKENS,
    payload: data,
})
export const successWithdrawLimitedTokens = data => ({
    type: LimitedTokensActionTypes.SUCCESS_WITHDRAW_LIMITED_TOKENS,
    payload: data,
})
export const finishWithdrawLimitedTokens = data => ({
    type: LimitedTokensActionTypes.FINISH_WITHDRAW_LIMITED_TOKENS,
    payload: data,
})
export const failureWithdrawLimitedTokens = data => ({
    type: LimitedTokensActionTypes.FAILURE_WITHDRAW_LIMITED_TOKENS,
    payload: data,
})

export const startSellLimitedTokens = data => ({
    type: LimitedTokensActionTypes.START_SELL_LIMITED_TOKENS,
    payload: data,
})
export const successSellLimitedTokens = data => ({
    type: LimitedTokensActionTypes.SUCCESS_SELL_LIMITED_TOKENS,
    payload: data,
})
export const finishSellLimitedTokens = data => ({
    type: LimitedTokensActionTypes.FINISH_SELL_LIMITED_TOKENS,
    payload: data,
})
export const failureSellLimitedTokens = data => ({
    type: LimitedTokensActionTypes.FAILURE_SELL_LIMITED_TOKENS,
    payload: data,
})

export const startGetSellLimitedTokensFee = data => ({
    type: LimitedTokensActionTypes.START_GET_SELL_LIMITED_TOKENS_FEE,
    payload: data,
})
export const successGetSellLimitedTokensFee = data => ({
    type: LimitedTokensActionTypes.SUCCESS_GET_SELL_LIMITED_TOKENS_FEE,
    payload: data,
})
export const finishGetSellLimitedTokensFee = data => ({
    type: LimitedTokensActionTypes.FINISH_GET_SELL_LIMITED_TOKENS_FEE,
    payload: data,
})
export const failureGetSellLimitedTokensFee = data => ({
    type: LimitedTokensActionTypes.FAILURE_GET_SELL_LIMITED_TOKENS_FEE,
    payload: data,
})

export const startGetLimitedTokenDetails = data => ({
    type: LimitedTokensActionTypes.START_GET_LIMITED_TOKEN_DETAILS,
    payload: data,
})
export const successGetLimitedTokenDetails = data => ({
    type: LimitedTokensActionTypes.SUCCESS_GET_LIMITED_TOKEN_DETAILS,
    payload: data,
})
export const finishGetLimitedTokenDetails = data => ({
    type: LimitedTokensActionTypes.FINISH_GET_LIMITED_TOKEN_DETAILS,
    payload: data,
})
export const failureGetLimitedTokenDetails = data => ({
    type: LimitedTokensActionTypes.FAILURE_GET_LIMITED_TOKEN_DETAILS,
    payload: data,
})

export const startGetBuyLimitedTokensFee = data => ({
    type: LimitedTokensActionTypes.START_GET_BUY_LIMITED_TOKENS_FEE,
    payload: data,
})
export const successGetBuyLimitedTokensFee = data => ({
    type: LimitedTokensActionTypes.SUCCESS_GET_BUY_LIMITED_TOKENS_FEE,
    payload: data,
})
export const finishGetBuyLimitedTokensFee = data => ({
    type: LimitedTokensActionTypes.FINISH_GET_BUY_LIMITED_TOKENS_FEE,
    payload: data,
})
export const failureGetBuyLimitedTokensFee = data => ({
    type: LimitedTokensActionTypes.FAILURE_GET_BUY_LIMITED_TOKENS_FEE,
    payload: data,
})

export const startFetchLimitedTokenHotWalletFee = data => ({
    type: LimitedTokensActionTypes.START_FETCH_LIMITED_TOKEN_HOT_WALLET_FEE,
    payload: data,
})
export const successFetchLimitedTokenHotWalletFee = data => ({
    type: LimitedTokensActionTypes.SUCCESS_FETCH_LIMITED_TOKEN_HOT_WALLET_FEE,
    payload: data,
})
export const finishFetchLimitedTokenHotWalletFee = data => ({
    type: LimitedTokensActionTypes.FINISH_FETCH_LIMITED_TOKEN_HOT_WALLET_FEE,
    payload: data,
})
export const failureFetchLimitedTokenHotWalletFee = data => ({
    type: LimitedTokensActionTypes.FAILURE_FETCH_LIMITED_TOKEN_HOT_WALLET_FEE,
    payload: data,
})

export const startRedeemLimitedTokens = data => ({
    type: LimitedTokensActionTypes.START_REDEEM_LIMITED_TOKENS,
    payload: data,
})
export const successRedeemLimitedTokens = data => ({
    type: LimitedTokensActionTypes.SUCCESS_REDEEM_LIMITED_TOKENS,
    payload: data,
})
export const finishRedeemLimitedTokens = data => ({
    type: LimitedTokensActionTypes.FINISH_REDEEM_LIMITED_TOKENS,
    payload: data,
})
export const failureRedeemLimitedTokens = data => ({
    type: LimitedTokensActionTypes.FAILURE_REDEEM_LIMITED_TOKENS,
    payload: data,
})
